import React, { useState, useEffect } from "react";
import { Icon } from "semantic-ui-react";
import "./JobListingForm.css";
import FormField from "../../../Components/FormField/FormField";
import ConfirmButton from "../../../Components/Buttons/ConfirmButton";
import FormDropdown from "../../../Components/FormField/FormDropdown";
import ButtonContainer from "../../../Components/CheckableButton/ButtonContainer";
import CheckableButton from "../../../Components/CheckableButton/CheckableButton";
import CancelButton from "../../../Components/Buttons/CancelButton";
import FormDatePicker from "../../../Components/FormField/FormDatePicker";
import Remuneration from "./Remuneration";
import { Link } from "react-router-dom";
import Modal from "../../../Components/Modal/Modal";
import TagsForm from "./TagsForm";
import { connect } from "react-redux";
import { API } from "../../../API";
// import ConfirmDelete from "./ConfirmDelete";

function JobListingForm(props) {
  const { qualifications, selectedList = [], levels, simpleQualifications } = props

  const [showTagsPopup, setShowTagsPopup] = useState(false);
  const [showDeletePopup, setShowDeletePopup] = useState(false);
  const [timezone, setTimezone] = useState(
    (props.campuses[0] && props.campuses[0].timezone) || ""
  );
  const [selectedByQualification, setSelectedByQualification] = useState({})
  const [simpleQualificationList, setSimpleQualifications] = useState(simpleQualifications)

  // const tagsArray = tagsToArray(props.state.tags);

  useEffect(() => {

    if(!simpleQualificationList?.length) {
      API.getSimpleQualification().then(res => {
        setSimpleQualifications(res?.data?.data)
      })
    }

    const selectedItem = {}
    const selectedByQualification = {}
    qualifications.forEach(item => {
        const quaList = item.qualifications
        if(item.type === 'vet') {
            quaList.forEach(qua => {
                const { units } = qua
                units.forEach(unit => {
                    if(selectedList.includes(unit._id)) {
                        if(selectedByQualification[qua._id]?.length) {
                            selectedByQualification[qua._id].push(unit._id)
                        }
                        else {
                            selectedByQualification[qua._id] = [unit._id]
                        }
                    }
                })
            })
        }
    })
    setSelectedByQualification(selectedByQualification)
  }, [])

  const getTagName = (levelID) => {
		const levelItem = simpleQualificationList.find(ele => ele._id === levelID)
		return levelItem ? (levelItem?.code ? `${levelItem.title} (${levelItem.code})` : levelItem.title)
			: levelID
	};

  const handleCampusChange = (evt) => {
    let targetCampus = props.campuses.find(
      (campus) => campus._id === evt.target.value
    );
    targetCampus && targetCampus.timezone
      ? setTimezone(targetCampus.timezone)
      : setTimezone("");
    props.handleFormFieldChange(evt);
  };

  const buildDayDeliveryOption = (id, text, checked) => {
    return (
      <CheckableButton
        className="mb-2"
        checkbox
        id={id}
        name="session-day"
        title={text}
        onChange={props.handleCheckboxChange}
        checked={checked}
      >
        {text}
      </CheckableButton>
    );
  };

  const buildListItem = (id, placeholder, value, onChange, compusory) => {
    return (
      <li className="sform">
        <FormField
          id={id}
          className=""
          placeholder={placeholder}
          required={compusory}
          value={value}
          onChange={onChange}
          minLength={50}
        />
      </li>
    );
  };

  return (
    <form onSubmit={props.onSubmit} className="row">
      <div className="col-lg-6">
        <FormField
          label="Job title"
          id="title"
          className=""
          placeholder="Job title"
          required
          value={props.state.title}
          onChange={props.handleFormFieldChange}
        />
        <div className="row">
          <div className="col">
            <ButtonContainer label="Department">
              {
                props.user?.is_childcare_centre ? (
                  <CheckableButton
                    id="is_ecec"
                    className="mb-3"
                    checked={true}
                  >
                    ECEC
                  </CheckableButton>
                ) : (
                  <>
                    <CheckableButton
                      id="is_elt"
                      className="mb-3"
                      checked={!props.state.is_vet}
                      onChange={props.handleCheckboxChange}
                    >
                      ELT
                    </CheckableButton>
                    <CheckableButton
                      id="is_vet"
                      className="mb-3"
                      checked={props.state.is_vet}
                      onChange={props.handleCheckboxChange}
                    >
                      VET / Digital & Tech
                    </CheckableButton>
                  </>
                )
              }
            </ButtonContainer>
          </div>
          <div className="col">
            <label>Descriptive Tags (up to 15)</label>
            <div id="tags">
              {selectedList.length
                ? selectedList.map((tag) => {
                    return (
                      <span className="listing-form-tag" key={tag}>
                        {getTagName(tag)}
                      </span>
                    );
                  })
                : "No tags added"}
            </div>
            <span
              className="listing-edit-tag-button ml-0 mt-2"
              onClick={() => setShowTagsPopup(true)}
            >
              <Icon name="edit" circular inverted></Icon> Add/Edit Tags
            </span>
          </div>
        </div>
        <div className="row" hidden={!props.state.is_vet || props.user?.is_childcare_centre}>
          <div className="col">
            <FormField
              label="Qualification or Course Name"
              id="qual_name"
              className=""
              placeholder="Qualification name"
              required={props.state.is_vet}
              value={props.state.qual_name}
              onChange={props.handleFormFieldChange}
            />
          </div>
          <div className="col">
            <FormField
              label="Course Code/s (If applicable)"
              id="course_code"
              className=""
              placeholder="Course code"
              required={props.state.is_vet}
              value={props.state.course_code}
              onChange={props.handleFormFieldChange}
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 column-fix">
            <FormDropdown
              label="Select a location from the list below or choose various checkbox"
              id="location"
              placeholder="Select location"
              required
              value={props.state.location}
              onChange={handleCampusChange}
              disabled={!props.campuses.length || props.state.various_campus}
              noMargin
            >
              {!props.campuses.length && (
                <option value="">You have no campuses</option>
              )} 
              {props.campuses.map((campus) => {
                return (
                  <option value={campus._id} key={campus._id}>
                    {campus.campus_shortname}
                  </option>
                );
              })}
            </FormDropdown>
            <Link to="/Campus" className="add-campus-link">
              {props.campuses.length ? "Add another campus?" : "Add a campus"}
            </Link>

            <CheckableButton
              toggle
              id="various_campus"
              className="mb-3"
              checked={props.state.various_campus}
              onChange={props.handleCheckboxChange}
            >
              Various
            </CheckableButton>
          </div>
          <div className="col-md-6 column-fix">
            <FormField
              label="Timezone"
              id="timezone"
              value={timezone}
              disabled
              nonHighlight
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-6 column-fix">
            <FormField
              label="Paid hours per week"
              id="weekly_hours"
              className=""
              // placeholder="0"
              required
              type="string"
              min="1"
              value={props.state.weekly_hours}
              onChange={props.handleFormFieldChange}
            />
          </div>
          <div className="col-md-6 column-fix">
            <FormField
              id="no_of_roles"
              label="Number of roles available"
              type="number"
              step="1"
              placeholder="Number of roles"
              value={props.state.no_of_roles}
              onChange={props.handleFormFieldChange}
            />
          </div>
        </div>
        <ButtonContainer label="Delivery mode" twoColumns vertical>
          <CheckableButton
            id="online_home"
            name="delivery_mode"
            className="mb-3"
            checked={props.state.delivery_mode === "online_home"}
            onChange={props.handleDeliveryModeChange}
          >
            Online; Deliver lesson from home
          </CheckableButton>
          <CheckableButton
            id="f2f_campus"
            name="delivery_mode"
            className="mb-3"
            checked={props.state.delivery_mode === "f2f_campus"}
            onChange={props.handleDeliveryModeChange}
          >
            Face-to-face (in-person); Deliver lesson on-campus
          </CheckableButton>
          <CheckableButton
            id="online_home_recorded"
            name="delivery_mode"
            className="mb-3"
            checked={props.state.delivery_mode === "online_home_recorded"}
            onChange={props.handleDeliveryModeChange}
          >
            All content pre-recorded by Teacher; no live/ synchronous delivery
            (Work from Home)
          </CheckableButton>
          <CheckableButton
            id="online_campus"
            name="delivery_mode"
            className="mb-3"
            checked={props.state.delivery_mode === "online_campus"}
            onChange={props.handleDeliveryModeChange}
          >
            Online; Deliver lesson on-campus
          </CheckableButton>
          <CheckableButton
            id="blended"
            name="delivery_mode"
            className="mb-3"
            checked={props.state.delivery_mode === "blended"}
            onChange={props.handleDeliveryModeChange}
          >
            Blended face-to-face/Online; Partly or fully deliver lesson
            on-campus
          </CheckableButton>
          <CheckableButton
            id="online_office_campus_recorded"
            name="delivery_mode"
            className="mb-3"
            checked={
              props.state.delivery_mode === "online_office_campus_recorded"
            }
            onChange={props.handleDeliveryModeChange}
          >
            All content pre-recorded by Teacher; no live/ synchronous delivery
            (Work from office location or campus)
          </CheckableButton>
        </ButtonContainer>
        <ButtonContainer label="Days of delivery" twoColumns vertical>
          {buildDayDeliveryOption("monday", "Monday", props.state.monday)}
          {buildDayDeliveryOption("tuesday", "Tuesday", props.state.tuesday)}
          {buildDayDeliveryOption(
            "wednesday",
            "Wednesday",
            props.state.wednesday
          )}
          {buildDayDeliveryOption("thursday", "Thursday", props.state.thursday)}
          {buildDayDeliveryOption("friday", "Friday", props.state.friday)}
          {buildDayDeliveryOption("saturday", "Saturday", props.state.saturday)}
          {buildDayDeliveryOption("sunday", "Sunday", props.state.sunday)}
          {buildDayDeliveryOption(
            "flexible_days",
            "Flexible Days",
            props.state.flexible_days
          )}
        </ButtonContainer>
        <br />
        <div className="row">
          {/* className="col-md-6 column-fix"  */}
          <FormDatePicker
            maxWidth
            label="Contract start date"
            id="start_date"
            className="col-md-4"
            // placeholderText={new Date()
            //   .toLocaleDateString()
            //   .split(/\//)
            //   .join("-")}
            showYearDropdown
            showMonthDropdown
            popperClassName="some-custom-class"
            isClearable
            placeholderText="Start date"
            showPopperArrow={false}
            dropdownMode="select"
            dateFormatCalendar="MMMM"
            dateFormat="dd-MM-yyyy"
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            minDate={props.state.close_date || new Date()}
            required
            selected={props.state.start_date}
            onChange={(date) => props.handleDateChange(date, "start_date")}
            disabled={props.state.display_various_dates}
          />
          <FormDatePicker
            maxWidth
            label="Contract end date"
            id="end_date"
            className="col-md-4"
            // placeholderText={new Date()
            //   .toLocaleDateString()
            //   .split(/\//)
            //   .join("-")}
            showYearDropdown
            showMonthDropdown
            popperClassName="some-custom-class"
            isClearable
            placeholderText="End date"
            showPopperArrow={false}
            dropdownMode="select"
            dateFormatCalendar="MMMM"
            dateFormat="dd-MM-yyyy"
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            minDate={props.state.start_date || new Date()}
            required
            selected={props.state.end_date}
            onChange={(date) => props.handleDateChange(date, "end_date")}
            disabled={props.state.display_various_dates}
          />
          <FormDatePicker
            maxWidth
            label="Application close date"
            id="close_date"
            // placeholderText={new Date()
            //   .toLocaleDateString()
            //   .split(/\//)
            //   .join("-")}
            showYearDropdown
            showMonthDropdown
            className="col-md-4"
            popperClassName="some-custom-class"
            isClearable
            placeholderText="Application close date"
            showPopperArrow={false}
            dropdownMode="select"
            dateFormatCalendar="MMMM"
            dateFormat="dd-MM-yyyy"
            yearDropdownItemNumber={10}
            scrollableYearDropdown
            required
            selected={props.state.close_date}
            onChange={(date) => props.handleDateChange(date, "close_date")}
            minDate={new Date()}
          />
        </div>
        <div className="salary_remuneration mt-4">
            <CheckableButton
              toggle
              id="display_various_dates"
              className="mb-3"
              checked={props.state.display_various_dates}
              onChange={props.handleCheckboxChange}
            >
              Various start dates throughout the year
            </CheckableButton>
            <CheckableButton
              toggle
              id="display_various_dates"
              className="mb-3"
              checked={props.state.display_various_dates}
              onChange={props.handleCheckboxChange}
            >
              12-24 months contract length
            </CheckableButton>
          </div>
        <div className="salary_remuneration mt-4">
          <CheckableButton
            toggle
            id="display_salary"
            className="mb-3"
            checked={props.state.display_salary}
            onChange={props.handleCheckboxChange}
          >
            Display Salary
          </CheckableButton>
          <Remuneration
            handleRemunerationChange={props.handleRemunerationChange}
            handleCurrencyValueChange={props.handleCurrencyValueChange}
            handleFormFieldChange={props.handleFormFieldChange}
            handleRadioChange={props.handleRadioChange}
            state={props.state}
          />
        </div>
      </div>
      <div className="col-lg-6">
        <FormField
          label="Job description"
          id="description"
          className=""
          placeholder="Provide a detailed description of the role you are advertising."
          required
          value={props.state.description}
          onChange={props.handleFormFieldChange}
          type="textarea"
        />

        <label>Responsibilities</label>
        <div className="responsibility_styling">
          <div className="styling_res">
            <ul>
              {buildListItem(
                "responsibility_1",
                "Responsibility 1",
                props.state.responsibility_1,
                props.handleFormFieldChange,
                true
              )}
              {buildListItem(
                "responsibility_2",
                "Responsibility 2",
                props.state.responsibility_2,
                props.handleFormFieldChange,
                true
              )}
              {buildListItem(
                "responsibility_3",
                "Responsibility 3 (Optional)",
                props.state.responsibility_3,
                props.handleFormFieldChange,
                false
              )}
            </ul>
          </div>
        </div>
        <br />
        <label>Benefits</label>
        <div className="responsibility_styling">
          <div className="styling_res">
            <ul>
              {buildListItem(
                "benefit_1",
                "Benefit 1",
                props.state.benefit_1,
                props.handleFormFieldChange,
                true
              )}
              {buildListItem(
                "benefit_2",
                "Benefit 2",
                props.state.benefit_2,
                props.handleFormFieldChange,
                true
              )}
              {buildListItem(
                "benefit_3",
                "Benefit 3 (Optional)",
                props.state.benefit_3,
                props.handleFormFieldChange,
                false
              )}
            </ul>
          </div>
        </div>
        <br />
        <label>Required Expertise/Qualifications</label>
        <div className="responsibility_styling">
          <div className="styling_res">
            <ul>
              {buildListItem(
                "expertise_1",
                "Expertise 1",
                props.state.expertise_1,
                props.handleFormFieldChange,
                true
              )}
              {buildListItem(
                "expertise_2",
                "Expertise 2",
                props.state.expertise_2,
                props.handleFormFieldChange,
                true
              )}
              {buildListItem(
                "expertise_3",
                "Expertise 3 (Optional)",
                props.state.expertise_3,
                props.handleFormFieldChange,
                false
              )}
            </ul>
          </div>
        </div>
        <br />
        <CheckableButton
          toggle
          id="instant_hire"
          name="instant_hire"
          checked={props.state.instant_hire}
          onChange={props.handleCheckboxChange}
        >
          Instant Hire On/Off (If on, interviews will not be required)
        </CheckableButton>
        <br />
        <CheckableButton
          toggle
          id="org_pro_visible"
          name="org_pro_visible"
          checked={props.state.org_pro_visible}
          onChange={props.handleCheckboxChange}
        >
          Make organisation Profile visible
        </CheckableButton>
      </div>

      <div className="row w-100 justify-content-center px-0 mt-3">
        <div className="col-md-3 d-flex justify-content-center">
          <CancelButton
            type="button"
            className="college_delete_campus mx-0 mt-3"
            onClick={props.onCancel}
          >
            Cancel Changes
          </CancelButton>
        </div>

        {props.state.status !== "published" && (
          <div className="col-md-3 column-fix d-flex justify-content-center">
            <CancelButton
              onClick={props.onDraft}
              className="college_submit mx-0 mt-3"
            >
              Save Draft
            </CancelButton>
          </div>
        )}

        {!!props.state._id && (
          <div className="col-md-3 column-fix d-flex justify-content-center">
            <CancelButton
              onClick={() => setShowDeletePopup(true)}
              className="college_submit mx-0 mt-3"
            >
              Delete Listing
            </CancelButton>
          </div>
        )}

        <div className="col-md-3 column-fix d-flex justify-content-center">
          <ConfirmButton type="submit" className="college_submit mx-0 mt-3">
            Preview and Publish
          </ConfirmButton>
        </div>
      </div>

      <TagsForm
        show={showTagsPopup}
        type="Tags"
        tags={props.state.tags}
        onSubmit={(tags) => {
          props.handleTagsChange(tags);
          setShowTagsPopup(false);
        }}
        onClose={() => setShowTagsPopup(false)}
        qualifications={qualifications}
        levels={levels}
        selectedList={selectedList}
        selectedByQualificationObj={selectedByQualification}
        isChildcareCentre={props.user?.is_childcare_centre}
      />

      <Modal
        show={showDeletePopup}
        onClose={() => setShowDeletePopup(false)}
        header="Delete Listing"
        className="delete-listing-modal"
      >
        <div className="w-100 center-text">
          Are you sure? This cannot be undone!
        </div>
        <div className="row">
          <div className="col-md-6">
            <CancelButton
              className="mt-3"
              onClick={() => setShowDeletePopup(false)}
            >
              Cancel
            </CancelButton>
          </div>
          <div className="col-md-6">
            <ConfirmButton className="mt-3" onClick={props.onDelete}>
              Delete Listing
            </ConfirmButton>
          </div>
        </div>
      </Modal>
    </form>
  );
}

const mapStateToProps = (state) => {
	return {
	  simpleQualifications: state.user?.simpleQualifications || []
	}
}

export default connect(mapStateToProps)(JobListingForm);
